export default {
  SEARCH_CATALOG_ALLIANZ_SOURCE_INCOME_QUERY: Symbol.for('SEARCH_CATALOG_ALLIANZ_SOURCE_INCOME_QUERY'),
  CATALOG_ALLIANZ_SOURCE_INCOME_REPOSITORY: Symbol.for('CATALOG_ALLIANZ_SOURCE_INCOME_REPOSITORY'),
  CATALOG_ALLIANZ_SOURCE_INCOME_STATE_MANAGER: Symbol.for('CATALOG_ALLIANZ_SOURCE_INCOME_STATE_MANAGER'),
};
